/** @type {import('tailwindcss').Config} */

module.exports = {
  plugins: [require("@tailwindcss/typography")],
  content: [
    "./src/pages/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/components/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/app/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/common/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/share/**/*.{js,ts,jsx,tsx,mdx}",
    "./src/**/*.{js,ts,jsx,tsx,mdx}",
    "./node_modules/@graphy/ui/**/*.js",
  ],
  safelist: ["bg-borangeLight", "bg-dashLight", "bg-dreadLight"],
  theme: {
    screens: {
      sm: "640px",
      md: "768px",
      lg: "1024px",
      xl: "1280px",
      "1.5xl": "1440px",
      "2xl": "1536px",
      "3xl": "1920px",
      "4xl": "2560px",
      tab: "640px",
      web: "1440px",
    },
    container: {
      center: true,
      screens: {
        sm: "640px",
        md: "768px",
        lg: "1088px",
        // xl/2xl enabled so wide-screen viewports get a wider container —
        // the HomeV2 platform tab bar needs the extra room so all 7 tabs
        // (Courses → AI Avatars) fit on one row without horizontal scroll.
        xl: "1280px",
        "2xl": "1440px",
      },
      padding: {
        DEFAULT: "1rem",
        sm: "2rem",
        lg: "4rem",
        xl: "5rem",
        "2xl": "6rem",
      },
    },
    colors: {
      alert: "#DAF6E7",
      backdrop: "rgba(61, 61, 61, 0.8)",
      barry: "#3F7484",
      barry01: "#172A30",
      barry02: "#2B505B",
      barry03: "#3F7484",
      barry04: "#F3F8F9",
      black: "#000000",
      black70: "#232228B3",
      black90: "#232228E6",
      blood: "#B92B39",
      brandPrimary: "#5766F2",
      brandPrimaryHover: "#4553D6",
      brandPrimaryDark: "#2D39B8",
      brandSecondary: "#D8FD49",
      brandSecondaryHover: "#C7EC38",
      blueGradient: {
        first: "#D2F2F9",
        second: "#D9E0F2",
      },
      blueGreenGradient: {
        first: "#E0E6FF",
        second: "#CCFFE3",
      },
      bluePinkGradient: {
        first: "#CCD6FF",
        second: "#FFCCCC",
      },
      bluePrimary: "#7287E6",
      blueYellowGradient: {
        first: "#D2F2F9",
        second: "#FBE0D0",
      },
      borange: "#F09059",
      borangeDark: "#9F430E",
      borangeLight: "#FCECE2",
      brass: "#F3E7D1",
      brass02: "#F9F2E7",
      brown: "#753723",
      citrine: "#FFC28A",
      citrineDark: "#EA8930",
      commander: "#F5B9B9",
      commander02: "#FADBDB",
      cta: {
        hover: "#312D89",
        pressed: "#070449",
        primary: "#2A2861",
      },
      dark: "#001511",
      dark2: "#1A2C29",
      darkBrass: "#EBD6AE",
      darkGreen: "#155532",
      darkGrey: "#667270",
      darkSapphire: "#000A30",
      darkSlate01: "#393f41",
      darkSlate02: "#878C91",
      darkSlate03: "#AAB1B7",
      darkSlate04: "#878C90",
      darkSlate05: "#53585B",
      darkSlate90: "#64748b90",
      dash: "#6A82E3",
      dashDark: "#4462DC",
      dashLight: "#EBEEFB",
      dashLightest: "#F5F7FF",
      dashboardTitle: "#305965",
      dread: "#E85555",
      dreadLight: "#FAD7D7",
      dust: "#F7F8F5",
      errorDark: "#96141B",
      errorLight: "#FFD8DA",
      errorLight02: "#FAEAEA",
      errorMid: "#FA4D56",
      errorMid01: "#E85555",
      facebookBg: "#1877F2",
      gold: "#FEFCB4",
      gold2: "#F8D372",
      gold3: "#DCB54F",
      gold4: "#C49722",
      goldGradient: {
        first: "rgb(196,151,34)",
        second: "#F8D372",
      },
      graphite: "#000908",
      graphite01: "#1E2C2A",
      graphite02: "#687270",
      graphite03: "#D4D7D7",
      graphite04: "#E2E2E2",
      graphitePrimary: "#041511",
      green: {
        0: "#D2FCE4",
        1: "#85EEB2",
        2: "#19CE67",
        3: "#10A750",
      },
      greenGradient: {
        first: "#D6F5E4",
        second: "#D9E0F2",
      },
      greenLight: "#DAF6E7",
      grey: {
        0: "#FFFFFF",
        1: "#F8F8FC",
        2: "#E9E9F2",
        3: "#7A7D94",
        4: "#3A3D50",
      },
      grey03: "#7A7D94",
      havelock: "#6A82E3",
      inherit: "inherit",
      juneBlue: "#317AE7",
      lightBlue: "#F8FFFF",
      lightGrey: "#FEFEFE",
      lightblueGradient: {
        first: "#D3F1F9BF",
        second: "#DAE0F3",
      },
      linkedInBlue: "#2967B2",
      modalBg: "#66000000",
      mogul: "#102D1E",
      mogul02: "#2B5740",
      neutralBlack: "#232228",
      neutralDefault01: "#171B2C",
      neutralDefault02: "#2C2F42",
      neutralDefault03: "#424659",
      // App Builder Preview
      neutralDefaultBg: "#090F26",
      neutralDefaultPrimary: "#152561",
      neutralTheme01: "#20182A",
      neutralTheme02: "#352D40",
      neutralTheme03: "#4C4357",
      neutralThemePrimary: "#6825B8",
      pink: {
        0: "#EF64F2",
      },
      pinkGradient: {
        first: "#FBE0D0",
        second: "#F4D7ED",
      },
      primary: "#5361E9",
      primaryBlack: "#01100D",
      primaryWhite: "#FFFFFF",
      purple: {
        0: "#F1F0FF",
        1: "#D7D6ED",
        2: "#8984FF",
        3: "#6059FF",
        4: "#2E27C3",
      },
      purpleGradient: {
        first: "#D9E0F2",
        second: "#F4D7ED",
      },
      red: {
        0: "#ED6750",
      },
      sandstone: "#FFFAED",
      sandstone01: "#FFFAED",
      sandstone02: "#FDFCFB",
      sandstone03: "#FCFAF8",
      sandstone04: "#F9F5F1",
      sapphire: "#020F3E",
      sapphire01: "#05144C",
      sapphire02: "#152561",
      sapphire03: "#091F6B",
      sapphire04: "#AFB6F6",
      sapphire05: "#E1E4FA",
      sapphireLight: "#D2D6FA",
      scholar: "#B1E2D0",
      scholar02: "#D2EEE4",
      seagreenLight: "#DAF6E780",
      secondaryBlack: "#182022",
      select: "#FFFDB5",
      selectBlack: "#0C0C0A",
      selection01: "#D2D6FF",
      selection02: "#EEEFFF",
      paleYellow: "#FFF8D4",
      slate: "#E5E5E5",
      slate01: "#282828",
      slate02: "#4A4A4A",
      slate03: "#A8A8A8",
      slate04: "#DFDFDF",
      slate05: "#F7F7F7",
      slateLight: "#F7F9FA",
      slateStroke: "#E5E5E5",
      slateStrokeLight: "#E5E5E580",
      spinach: "#CCFFE3",
      spinachLight: "#E0FBEE",
      stroke: "#2A3234",
      successDark: "#12732D",
      successLight: "#D3FFE0",
      successMid: "#42BE65",
      textGradient: {
        dash: "#6A82E3",
        dread: "#E85555",
      },
      transparent: "transparent",
      warningDark: "#CEA511",
      warningLight: "#FFF8E0",
      warningMid: "#F1C21B",
      white: "#FFFFFF",
      white02: "#FFFEFA",
      white03: "#FCFCFB",
      white30: "#FFFFFF54",
      white70: "#FFFFFFB3",
      white90: "#FFFFFFE6",
      yellow: {
        0: "#FFF5D3",
        1: "#FFDF70",
        2: "#FFCF26",
        3: "#E2B102",
        4: "#877102",
      },
    },
    fontFamily: {
      caveat: ["Caveat", "cursive"],
      // `var(--font-inter)` is set by next/font/google in _app.tsx and
      // resolves to a self-hosted Inter. The bare "Inter" entries are
      // kept as a fallback for environments where the variable isn't set.
      inter: ["var(--font-inter)", "Inter", "Roobert", "serif"],
      roobert: ["Roobert", "var(--font-inter)", "Inter", "serif"],
      garamond: ["garamond-premier-pro", "serif"],
      manrope: ["Manrope", "var(--font-inter)", "Inter"],
      "graphy-icons": ["GraphyIcons", "sans-serif"],
      "inter": ["var(--font-inter)", "Inter", "sans-serif"]
    },
    extend: {
      fontFamily: {
        // `font-sans` historically pointed at Instrument Sans (Bold),
        // but the new graphy.com design uses Inter Medium for every
        // heading. Keep Instrument Sans available as `font-instrument`
        // for any legacy component that still needs it.
        sans: ["var(--font-inter)", "Inter", "var(--font-instrument-sans)", "sans-serif"],
        instrument: ["var(--font-instrument-sans)"],
      },
      backgroundImage: {
        "green-gradient":
          "linear-gradient(105.73deg, #1AD0AF -6.21%, #13B570 48.71%, #10A750 117.04%)",
        "green-gradient-hover":
          "linear-gradient(105.73deg, #56EACF -6.21%, #13B570 63.51%, #10A750 117.04%)",
        "green-gradient-pressed":
          "linear-gradient(105.73deg, #18AE93 -6.21%, #0E8C56 48.71%, #0B9646 117.04%)",
        "blue-gradient":
          "conic-gradient(from 225deg at 66.56% 74.96%, #2563EB 105.81175088882446deg, #3264DF 190.07396936416626deg, #3665DC 194.46781396865845deg, #1D4ED8 206.71821355819702deg, #2052D9 325.23854970932007deg)",
        "blue-gradient-hover":
          "conic-gradient(from 225deg at 66.56% 74.96%, #405DE5 105.81175088882446deg, #5851DB 190.07396936416626deg, #6154DB 194.46781396865845deg, #3C4AC0 206.71821355819702deg, #4853C0 325.23854970932007deg)",
        "blue-gradient-pressed":
          "conic-gradient(from 225deg at 66.56% 74.96%, #1D3EA5 105.81175088882446deg, #3242A0 190.07396936416626deg, #3644A0 194.46781396865845deg, #1A2976 206.71821355819702deg, #1E2C76 325.23854970932007deg)",
        "primary-gradient":
          "radial-gradient(51.51% 61.24% at 2.65% 1.91%, rgba(105, 111, 255, 0.50) 0%, rgba(105, 111, 255, 0.00) 100%)",
        "estimation-section":
          "linear-gradient(348deg, rgba(241, 240, 255, 0.56) 12.59%, #F1F0FF 51.51%, rgba(216, 250, 233, 0.91) 89.04%)",
        aurora1:
          "linear-gradient(279.72deg, rgba(241, 240, 255, 0.555876) -1.94%, #F1F0FF 41.28%, rgba(216, 250, 233, 0.913201) 82.95%)",
        aurora2:
          "linear-gradient(348deg, rgba(241, 240, 255, 0.56) 12.59%, #F1F0FF 51.51%, rgba(216, 250, 233, 0.91) 89.04%)",
      },
      keyframes: {
        slideUpAndFade: {
          from: { opacity: 0, transform: "translateY(2px)" },
          to: { opacity: 1, transform: "translateY(0)" },
        },
        slideRightAndFade: {
          from: { opacity: 0, transform: "translateX(-2px)" },
          to: { opacity: 1, transform: "translateX(0)" },
        },
        slideDownAndFade: {
          from: { opacity: 0, transform: "translateY(-2px)" },
          to: { opacity: 1, transform: "translateY(0)" },
        },
        slideLeftAndFade: {
          from: { opacity: 0, transform: "translateX(2px)" },
          to: { opacity: 1, transform: "translateX(0)" },
        },
      },
      animation: {
        slideUpAndFade: "slideUpAndFade 400ms cubic-bezier(0.16, 1, 0.3, 1)",
        slideRightAndFade:
          "slideRightAndFade 400ms cubic-bezier(0.16, 1, 0.3, 1)",
        slideDownAndFade:
          "slideDownAndFade 400ms cubic-bezier(0.16, 1, 0.3, 1)",
        slideLeftAndFade:
          "slideLeftAndFade 400ms cubic-bezier(0.16, 1, 0.3, 1)",
        "marquee-left": "marquee-left 5s infinite linear",
        "marquee-right": "marquee-right 5s infinite linear",
      },
      fontSize: {
        64: ["4rem", "4.5rem"], // 64px
        title44: ["2.75rem", "2.5rem"], // 44px
        title40: ["2.5rem", "2.4rem"], // 40px
        title36: ["2.25rem", "2.25rem"], // 36px
        title1: ["2rem", "2.5rem"], // 32px
        title2: ["1.75rem", "2.25rem"], // 28px
        title26: ["1.625rem", "2.25rem"], // 26px
        title3: ["1.5rem", "2.25rem"], // 24px
        title4: ["1.375rem", "1.75rem"], // 22px
        title5: ["1.125rem", "1.5rem"], // 18px
        title6: ["1rem", "1.5rem"], // 16px
        body: ["0.875rem", "1.25rem"], // 14px
        caption: ["0.75rem", "1rem"], // 12px
        footnote: ["0.625rem", "1rem"], // 10px
        "title-10": [
          "0.625rem", // 10px
          {
            lineHeight: "0.625rem",
            letterSpacing: "0.04em",
            fontWeight: "700",
          },
        ],
        "title-12": [
          "0.75rem", // 12px
          {
            lineHeight: "0.75rem",
            letterSpacing: "0.02em",
            fontWeight: "600",
          },
        ],
        "title-14": [
          "0.875rem", // 14px
          {
            lineHeight: "1.25rem",
            // letterSpacing: "0.02em",
            fontWeight: "600",
          },
        ],
        "title-16": [
          "1rem", // 16px
          {
            lineHeight: "1.5rem",
            letterSpacing: "-0.005em",
            fontWeight: "600",
          },
        ],
        "title-20": [
          "1.25rem", // 18px
          {
            lineHeight: "1.625rem",
            letterSpacing: "-0.005em",
            fontWeight: "600",
          },
        ],
        "title-24": [
          "1.5rem", // 24px
          {
            lineHeight: "2rem",
            letterSpacing: "-0.005em",
            fontWeight: "600",
          },
        ],
        "title-32": [
          "2rem", // 32px
          {
            lineHeight: "2.5rem",
            letterSpacing: "-0.01em",
            fontWeight: "600",
          },
        ],
        "title-48": [
          "3rem", // 48px
          {
            lineHeight: "3.5rem",
            letterSpacing: "-0.01em",
            fontWeight: "600",
          },
        ],
        "display-64": [
          "4rem", // 64px
          {
            lineHeight: "4.5rem",
            letterSpacing: "-0.01em",
            fontWeight: "400",
          },
        ],
        "display-64B": [
          "4rem", // 64px
          {
            lineHeight: "4.5rem",
            // letterSpacing: "1em",
            fontWeight: "700",
          },
        ],
        "body-10": [
          "0.625rem", // 10px
          {
            lineHeight: "0.875rem",
            letterSpacing: "0.02em",
            fontWeight: "400",
          },
        ],
        "body-12": [
          "0.75rem", // 12px
          {
            lineHeight: "1rem",
            // letterSpacing: "0.02em",
            fontWeight: "400",
          },
        ],
        "body-14": [
          "0.875rem", // 14px
          {
            lineHeight: "1.25rem",
            // letterSpacing: "0.02em",
            fontWeight: "400",
          },
        ],
        "body-16": [
          "1rem", // 16px
          {
            lineHeight: "1.5rem",
            // letterSpacing: "0.02em",
            fontWeight: "400",
          },
        ],
        "body-24": [
          "1.5rem", // 24px
          {
            lineHeight: "2rem",
            letterSpacing: "-0.005em",
            fontWeight: "400",
          },
        ],
      },

      screens: {
        windowsHeight: {
          raw: "(max-height: 900px)",
        },
        smallWindowsHeight: {
          raw: "(max-height: 800px)",
        },
      },
      maxHeight: {
        112: "28rem",
      },

      boxShadow: {
        elevationLow: "0px 0px 4px rgba(0, 0, 0, 0.125)",
        elevationHigh: "0px 0px 16px rgba(0, 0, 0, 0.125);",
        elevationPrimary: "0px 0px 16px rgba(83, 97, 233, 0.5)",
        purpleShadow: "0px 19px 0px -12px #bcbfff",
      },
      zIndex: {
        100: "100",
        alert: "1050",
        bar: "1100",
        fc: "1150",
        drawerOverlay: "1201",
        drawer: "1202",
        impAlert: "1250",
        modalOverlay: "1290",
        modal: "1300",
        popover: "1350",
        snackbar: "1400",
        tooltip: "1500",
        override: "9999",
      },
      letterSpacing: {
        extraSmall: "0.3px",
        small: "0.5px",
        medium: "1px",
        // tightest: '-.075em',
        // tighter: '-.05em',
        tight: "-.025em",
        // normal: '0',
        // wide: '.025em',
        // wider: '.05em',
        // widest: '.1em',
        ultrawide: ".2em",
      },

      lineHeight: {
        "title-1": "39.6px",
        "title-2": "36px",
        body: "19.2px",
        numb: "0",
      },
    },
  },
  variants: {
    animation: ["motion-safe"],
  },
};
